import SyncIcon from '@mui/icons-material/Sync';
import type { ResourceProps } from 'react-admin';

import QueueStatusList from './QueueStatusList';

const shopifySyncResource: Omit<ResourceProps, 'children'> = {
  name: 'shopify-sync',
  list: QueueStatusList,
  icon: SyncIcon,
  options: { label: 'Queue Status' },
};

export default shopifySyncResource;

export { shopifySyncDataProvider } from './dataProvider';
